export default function (app) {
  app.settings.homePath = "/";

  const setLanguage = (lang) => {
    app.settings.lang = lang;
    app.settings.homePath = lang === app.settings.defaultLanguage ? "/" : `/${lang}`;
    app.event("language", { lang });
  };

  app.storage.on("setItem", -100, ({ id, value }) => {
    if (id === "language") setLanguage(value);
  });

  app.on("loaded", async () => {
    const { data } = await app.database.language.search({ sortby: ["position"] });
    if (!data?.length) return;

    const visible = data.filter(({ hidden }) => !hidden);
    app.settings.defaultLanguage = (data.find((language) => language.default) || visible[0] || data[0])._id;

    const followPath = () => {
      const [, first] = window.location.pathname.split("/");
      if (first === "admin") return;

      const lang = data.find(({ _id }) => _id === first)?._id || app.settings.defaultLanguage;
      if (lang !== app.settings.lang) app.storage.setItem({ id: "language", value: lang });
    };
    window.addEventListener("locationchange", followPath);

    if (window.location.pathname.startsWith("/admin")) {
      const { value } = await app.storage.getItem({ id: "language" });
      setLanguage(visible.find(({ _id }) => _id === value)?._id || app.settings.defaultLanguage);
      return;
    }

    if (window.location.pathname === "/") {
      const { value: detected } = await app.storage.getItem({ id: "languageDetected" });
      if (!detected) {
        app.storage.setItem({ id: "languageDetected", value: "true" });
        const preferred = navigator.languages
          .map((code) => visible.find(({ _id }) => _id === code.split("-")[0].toLowerCase()))
          .find(Boolean);
        if (preferred?.autodetect && preferred._id !== app.settings.defaultLanguage)
          window.history.replaceState({}, "", `/${preferred._id}`);
      }
    }
    followPath();
  });
}
